"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
var _material = require("@mui/material");
var _getResource = require("../../utilities/getResource");
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _CustomRadioGroup = _interopRequireDefault(require("./CustomRadioGroup"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _organizations = require("../../actions/organizations.actions");
var _countries = require("../../actions/countries.actions");
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    form: '',
    formControl: '',
    formControlNoBottom: '',
    formControlDesc: '',
    padTop: '',
    titleOne: '',
    textField: '',
    select: '',
    radioGroup: '',
    button: '',
    smallSelect: '',
    hint: '',
    datePicker: ''
  };
};
var CustomAddress = /*#__PURE__*/function (_Component) {
  function CustomAddress(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomAddress);
    _this = _callSuper(this, CustomAddress, [props]);
    _this.state = {
      openAddressList: false,
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      stateID: '',
      countryID: '',
      longitude: '',
      latitude: '',
      selectedcountry: {},
      selectedstate: {},
      stateList: [],
      addressResult: [],
      selectedAddressIndex: '',
      validatingStatus: false
    };
    _this.updateSelectedValueField = _this.updateSelectedValueField.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleOk = _this.handleOk.bind(_this);
    _this.validateAddress = _this.validateAddress.bind(_this);
    _this.selectValidatedAddress = _this.selectValidatedAddress.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    //[('validateAddress', 'updateSelectedValueField', 'handleClose', 'handleOk')].map((item) => (this[item] = this[item].bind(this)));
    return _this;
  }
  (0, _inherits2["default"])(CustomAddress, _Component);
  return (0, _createClass2["default"])(CustomAddress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        countriesList = _this$props.countriesList,
        regions = _this$props.regions,
        value = _this$props.value;
      (0, _lodash.isEmpty)(countriesList) && this.props.getCountriesList();
      (0, _lodash.isEmpty)(regions) && this.props.getRegions();
      value.forEach(function (v) {
        var a = JSON.parse(v);
        var stateItem = (0, _lodash.find)(regions, function (r) {
          return Number(r.geographicalRegionID) === Number(a.stateID);
        });
        var selectedstate = {
          value: '',
          label: ''
        };
        if (stateItem) {
          selectedstate = {
            value: stateItem.geographicalRegionID,
            label: stateItem.geographicalRegion
          };
        }
        var selectedcountry = (0, _lodash.find)(countriesList, function (c) {
          return Number(c.value) === a.countryID;
        });
        if (a.countryID) {
          var filteredRegion = (0, _lodash.filter)(_this2.props.regions, {
            countryID: a.countryID
          });
          _this2.setState({
            stateList: filteredRegion
          });
        } else {
          _this2.setState({
            stateList: regions
          });
        }
        _this2.setState({
          address1: a.addressLine1,
          address2: a.addressLine2,
          city: a.city,
          stateID: a.stateID,
          countryID: a.countryID,
          longitude: a.longitude,
          latitude: a.latitude,
          selectedstate: selectedstate,
          zip: a.zip,
          selectedcountry: selectedcountry,
          state: selectedstate.label,
          country: selectedcountry ? selectedcountry.label : ''
        });
      });
    }
  }, {
    key: "validateAddress",
    value: function validateAddress() {
      var _this3 = this;
      var _this$state = this.state,
        address1 = _this$state.address1,
        address2 = _this$state.address2,
        city = _this$state.city,
        state = _this$state.state,
        zip = _this$state.zip,
        country = _this$state.country,
        stateList = _this$state.stateList;
      var countriesList = this.props.countriesList;
      var input = {
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        zip: zip,
        country: country,
        stateList: stateList,
        countryList: countriesList
      };
      this.setState({
        validatingStatus: true
      }, function () {
        if (country !== '') {
          _this3.props.validateAddress(input).then(function (result) {
            _this3.setState({
              openAddressList: true,
              addressResult: result.response
            });
          });
        } else {
          _this3.setState({
            openAddressList: true,
            addressResult: []
          });
        }
      });
    }
  }, {
    key: "updateText",
    value: function updateText(field) {
      var _this4 = this;
      return function (value) {
        _this4.setState((0, _defineProperty2["default"])({}, field, value.target.value));
      };
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      var _this$state2 = this.state,
        address1 = _this$state2.address1,
        address2 = _this$state2.address2,
        city = _this$state2.city,
        stateID = _this$state2.stateID,
        zip = _this$state2.zip,
        countryID = _this$state2.countryID,
        longitude = _this$state2.longitude,
        latitude = _this$state2.latitude;
      this.props.onChange(this.convertToValue(address1, address2, city, stateID, zip, countryID, longitude, latitude));
    }
  }, {
    key: "updateSelectedValueField",
    value: function updateSelectedValueField(field) {
      var _this5 = this;
      return function (event, value) {
        if (field === 'country') {
          var filteredRegion = (0, _lodash.filter)(_this5.props.regions, {
            countryID: value['value']
          });
          _this5.setState({
            stateList: filteredRegion
          });
          _this5.props.onCountryChange(value['value']);
        }
        _this5.setState((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, field, value['label']), "".concat(field, "ID"), value['value']), "selected".concat(field), value), function () {
          var _this5$state = _this5.state,
            address1 = _this5$state.address1,
            address2 = _this5$state.address2,
            city = _this5$state.city,
            stateID = _this5$state.stateID,
            zip = _this5$state.zip,
            countryID = _this5$state.countryID;
          _this5.props.onChange(_this5.convertToValue(address1, address2, city, stateID, zip, countryID));
        });
      };
    }
  }, {
    key: "selectValidatedAddress",
    value: function selectValidatedAddress(idx) {
      this.setState({
        selectedAddressIndex: Number(idx)
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        openAddressList: false,
        validatingStatus: false,
        selectedAddressIndex: ''
      });
    }
  }, {
    key: "handleOk",
    value: function handleOk() {
      var _this6 = this;
      var _this$state3 = this.state,
        addressResult = _this$state3.addressResult,
        selectedAddressIndex = _this$state3.selectedAddressIndex;
      var _this$props2 = this.props,
        countriesList = _this$props2.countriesList,
        regions = _this$props2.regions;
      if (selectedAddressIndex !== '') {
        var a = addressResult[selectedAddressIndex];
        var stateItem = (0, _lodash.find)(regions, function (r) {
          return Number(r.geographicalRegionID) === Number(a.stateID);
        });
        var selectedstate = {
          value: stateItem.geographicalRegionID,
          label: stateItem.geographicalRegion
        };
        var selectedcountry = (0, _lodash.find)(countriesList, function (c) {
          return Number(c.value) === a.countryID;
        });
        this.setState({
          address1: a.addressLine1,
          address2: a.addressLine2,
          city: a.city,
          selectedstate: selectedstate,
          zip: a.postalCode,
          selectedcountry: selectedcountry,
          stateID: a.stateID,
          countryID: a.countryID,
          longitude: a.longitude,
          latitude: a.latitude,
          validatingStatus: false,
          selectedAddressIndex: ''
        }, function () {
          var _this6$state = _this6.state,
            address1 = _this6$state.address1,
            address2 = _this6$state.address2,
            city = _this6$state.city,
            stateID = _this6$state.stateID,
            zip = _this6$state.zip,
            countryID = _this6$state.countryID,
            longitude = _this6$state.longitude,
            latitude = _this6$state.latitude;
          _this6.props.onChange(_this6.convertToValue(address1, address2, city, stateID, zip, countryID, longitude, latitude));
        });
      }
      this.setState({
        openAddressList: false
      });
    }
  }, {
    key: "getAddressList",
    value: function getAddressList(addressResult) {
      var _this7 = this;
      return addressResult.map(function (a, idx) {
        return {
          value: idx,
          label: _this7.formatAddress(a)
        };
      });
    }
  }, {
    key: "formatAddress",
    value: function formatAddress(a) {
      var _this$props3 = this.props,
        countriesList = _this$props3.countriesList,
        regions = _this$props3.regions;
      return (a.addressLine1 && a.addressLine1 !== '' ? a.addressLine1 : '') + (a.addressLine2 && a.addressLine2 !== '' ? ', ' + a.addressLine2 : '') + (a.city && a.city !== '' ? ', ' + a.city : '') + (a.stateID ? ', ' + (0, _lodash.find)(regions, function (r) {
        return Number(r.geographicalRegionID) === Number(a.stateID);
      }).geographicalRegion : '') + (a.countryID ? ', ' + (0, _lodash.find)(countriesList, function (c) {
        return Number(c.value) === Number(a.countryID);
      }).label : '') + (a.postalCode && a.postalCode !== '' ? ', ' + a.postalCode : '');
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(addressLine1, addressLine2, city, stateID, zip, countryID, longitude, latitude) {
      return [JSON.stringify({
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        city: city,
        stateID: stateID,
        zip: zip,
        countryID: countryID,
        longitude: longitude,
        latitude: latitude
      })];
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        resources = _this$props4.resources,
        language = _this$props4.language,
        countriesList = _this$props4.countriesList;
      var _this$state4 = this.state,
        address1 = _this$state4.address1,
        address2 = _this$state4.address2,
        city = _this$state4.city,
        zip = _this$state4.zip,
        stateList = _this$state4.stateList,
        addressResult = _this$state4.addressResult,
        validatingStatus = _this$state4.validatingStatus;
      var blankOption = [{
        label: '',
        value: ''
      }];
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        maxWidth: 'md',
        open: this.state.openAddressList,
        onClose: this.handleClose,
        "aria-labelledby": "form-dialog-title"
      }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
        id: "form-dialog-title"
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Address')), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, addressResult && addressResult.length > 0 ? /*#__PURE__*/_react["default"].createElement(_CustomRadioGroup["default"], {
        hideClearButton: true,
        direction: "horizontal",
        answers: this.getAddressList(addressResult),
        onChange: function onChange(event) {
          _this8.selectValidatedAddress(event.target.value);
        },
        value: this.state.selectedAddressIndex
      }) : (0, _getResource.getResource)(resources, language, 'Message', 'Address not found')), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        onClick: this.handleClose,
        color: "primary"
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Cancel')), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        onClick: this.handleOk,
        color: "primary"
      }, (0, _getResource.getResource)(resources, language, 'Label', 'OK')))), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Address')), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        className: classes.textField,
        key: "address1",
        margin: "dense",
        name: "address1",
        onChange: this.updateText('address1'),
        onBlur: this.onBlur,
        value: address1 || ''
      }), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Address 2')), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        className: classes.textField,
        key: "address2",
        margin: "dense",
        name: "address2",
        onChange: this.updateText('address2'),
        onBlur: this.onBlur,
        value: address2 || ''
      }), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'City')), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        className: classes.textField,
        key: "city",
        margin: "dense",
        name: "city",
        onChange: this.updateText('city'),
        onBlur: this.onBlur,
        value: city || ''
      }), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Zip Code')), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        className: classes.textField,
        key: "zip",
        margin: "dense",
        name: "zip",
        onChange: this.updateText('zip'),
        onBlur: this.onBlur,
        value: zip || ''
      }), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Country')), /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
        name: "country",
        value: this.state.selectedcountry,
        onChange: this.updateSelectedValueField,
        options: blankOption.concat(countriesList)
      }), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'State')), /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
        fullWidth: true,
        name: "state",
        value: this.state.selectedstate,
        onChange: this.updateSelectedValueField,
        options: blankOption.concat(stateList.map(function (s) {
          return {
            value: s.geographicalRegionID,
            label: s.geographicalRegion
          };
        }))
      }), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        color: "primary",
        className: classes.button,
        disabled: validatingStatus,
        onClick: function onClick() {
          return _this8.validateAddress();
        }
      }, (0, _getResource.getResource)(resources, language, 'Label', validatingStatus ? 'Validating Address...' : 'Validate Address')));
    }
  }]);
}(_react.Component);
CustomAddress.propTypes = {
  value: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired
};
function mapStateToProps(state, props) {
  return {
    isLoading: state.organizations.get('isLoading') || state.countries.get('isLoading'),
    addressValidationResult: state.organizations.get('addressValidationResult'),
    regions: state.countries.get('regions'),
    countriesList: state.countries.get('countriesList')
  };
}
var _default = exports["default"] = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(mapStateToProps, {
  validateAddress: _organizations.validateAddress,
  getCountriesList: _countries.getCountriesList,
  getRegions: _countries.getRegions
})(CustomAddress));